import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFramerComponent } from './simple-icons-framer.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFramerComponent ],
    exports:      [ SimpleIconsFramerComponent ],
    bootstrap:    []
})
export class SimpleIconsFramerModule {}
